import {
    getQueryString,
    invokeApp,
    setStorage,
    getStorage,
    clearStorage,
    removeStorage,
} from "@/util";
const languageMixin = {
	data() {
		return {
			showLanguages:false,
		}
	},
    created() {
		// lang 修正
		if(getStorage('changeLang') && getStorage('lang') != this.$common.lang)
		{
			this.setLanguage(getStorage('lang'))
		}
	},
	methods: {
		selectLanguage(lang){
            setStorage('changeLang', true)
			this.showLanguages = false
			this.setLanguage(lang)
		},
		setLanguage(lang){
			var url = window.location.href
			url = url.replace('lang='+this.$common.lang, 'lang='+lang)
			setStorage('lang', lang)
			this.$i18n.locale = lang
			this.$common.lang = lang
			window.location.href=url
            location.reload()
		},
	}
}
export default languageMixin